import { useEffect, useState } from "react";
import { getIn, useFormikContext } from "formik";

import { getPlanDays, getPlanLabel, getPlanMonths } from "./AdditionsPlan";
import { IRenter } from "../../../../../../../types/renter.type";
import { BondRenterVehicle } from "../../../../../../../common/services/renters.api";
import { saveVehicleRecords } from "../../../../../../../common/services/vehicles.api";

import ComboBoxFormik from "../../../../../../../common/components/form/ComboBoxFormik";
import SlideToggle from "../../../../../../../common/components/ui/toggleSwitch/SlideToggle";
import { AvailableVehiclesFieldFormik } from "../../../../forms/fields/AvailableVehiclesFieldFormik";
import VehicleBondingFlow from "../../../../../../../common/components/ui/registerVehilcePhotos/VehicleBondingFlow";

type Period = {
  value: string;
  label: string;
  months: number;
  days?: number;
};

type Props = {
  data: IRenter;
};

export default function ChangeVehicleModal(props: Props) {
  const renter = props.data;
  const formik = useFormikContext();

  const [isLicensePlateEmpty, setIsLicensePlateEmpty] = useState(false);
  const [isCheckOption, setIsCheckOption] = useState(false);
  const [complement, setComplement] = useState("");

  const renterId = getIn(formik.values, "renterId");
  const additions = getIn(formik.values, "additions");
  const vehicleId =
    getIn(formik.values, "vehicle._id") || getIn(formik.values, "vehicleId");

  const licensePlate = renter.activationData?.vehicle.licensePlate;
  const plantype = renter.activationData?.plan.planType;

  const initialRegisters = [
    { type: "Frente do veículo", content: "" },
    { type: "Lateral direita do veículo", content: "" },
    { type: "Lateral esquerda do veículo", content: "" },
    { type: "Traseira do veículo", content: "" },
    { type: "Odômetro", content: "" },
  ];

  const period: Period = {
    value: plantype || "",
    label: getPlanLabel(plantype || ""),
    months: getPlanMonths(plantype || ""),
    days: getPlanDays(plantype || ""),
  };

  useEffect(() => {
    setIsLicensePlateEmpty(!licensePlate);
  }, [licensePlate]);

  useEffect(() => {
    formik.setFieldValue("registers", initialRegisters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contractData = {
    renterId,
    vehicleId: vehicleId || "",
    period,
    additions: additions || [],
  };

  return (
    <section className="flex flex-col gap-4">
      <div>
        {isLicensePlateEmpty ? (
          <div
            className="bg-bluePrimary/20 border-l-4 border-yellow-500 p-4"
            role="alert"
          >
            <p className="font-bold">Atenção</p>
            <p>O cliente está apto a receber uma nova moto!</p>
          </div>
        ) : (
          <div
            className="bg-redPrimary/20 border-l-4 border-red-500 p-4"
            role="alert"
          >
            <p className="font-bold">Atenção</p>
            <p>O cliente não está apto a receber uma nova moto!</p>
          </div>
        )}

        <div className="mt-2 border-t pt-2">
          <div className="mt-2">
            <h2 className="text-2xl font-semibold">Vinculo da nova moto</h2>
          </div>

          <VehicleBondingFlow
            renterId={renter._id!}
            renterName={renter.name}
            onSavePhotos={saveVehicleRecords}
            onBond={BondRenterVehicle}
            showVehicleSelector={true}
            contractData={contractData}
            buttonLabel="Vincular"
            showPhotosDeliveryWarning={true}
            additionalFields={
              <>
                <ComboBoxFormik
                  name="reason"
                  label="Motivo da troca"
                  options={[
                    { value: "", label: "-" },
                    { value: "Acidente", label: "Acidente" },
                    {
                      value: "AtualizaçãoContrato:",
                      label: "Atualização do Contrato",
                    },
                    { value: "NovaMoto", label: "Entrega da Nova Moto" },
                    { value: "MotoReserva", label: "Entrega de Moto Reserva" },
                    {
                      value: "problemasMecanicos",
                      label: "Problemas Mecânicos",
                    },
                    { value: "RouboFurto", label: "Roubo/Furto" },
                    { value: "Outro", label: "Outros" },
                  ]}
                  required={true}
                />

                <div className="flex flex-col gap-1 mt-2">
                  <label
                    className="block text-sm font-medium text-gray-600"
                    htmlFor="otherReason"
                  >
                    Complemento
                  </label>
                  <textarea
                    id="otherReason"
                    name="complement"
                    value={complement}
                    onChange={(e) => {
                      setComplement(e.target.value);
                      formik.setFieldValue("complement", e.target.value);
                    }}
                    style={{ resize: "none", height: "90px" }}
                    className="border rounded p-2"
                  />
                </div>

                <div className="pb-3 flex items-center justify-center">
                  <span
                    className={`font-semibold text-[14px] mr-4 ${!isCheckOption ? "text-blue-600" : "text-gray-500"
                      }`}
                  >
                    Troca de Moto (Definitivamente)
                  </span>

                  <SlideToggle
                    name="isCheckOption"
                    onToggle={(checked) => {
                      setIsCheckOption(checked);
                      formik.setFieldValue("isCheckOption", checked);
                    }}
                  />

                  <span
                    className={`font-semibold text-[14px] ml-4 ${isCheckOption ? "text-blue-600" : "text-gray-500"
                      }`}
                  >
                    Moto Reserva (Temporariamente)
                  </span>
                </div>
              </>
            }
            vehicleSelectorComponent={
              <AvailableVehiclesFieldFormik
                listAll={false}
                companyId={renter.companyId}
                renterId={renter._id}
                required={true}
                reservedVehicle={isCheckOption}
              />
            }
          />
        </div>
      </div>
    </section>
  );
}
